import { map } from 'rxjs/operators';
import { CoralResponse, UnknownCoralError } from '../client';
import { CoralModel, } from '../model';
export class CoralClientSerdesInterceptor {
    constructor(operations = {}, syntheticExceptions = []) {
        this.operations = operations;
        this.syntheticExceptions = syntheticExceptions;
    }
    intercept(request, next) {
        const response = next.handle(this.withSerializedBody(request));
        const coralOperation = this.operations[request.operation];
        if (!coralOperation)
            return response;
        return response.pipe(map(response => {
            const body = response.body;
            if (response.ok) {
                const deserializationFn = coralOperation.deserializationFn;
                return new CoralResponse(Object.assign(Object.assign({}, response), { body: (deserializationFn ? deserializationFn(body) : body) }));
            }
            else {
                const exception = []
                    .concat(this.syntheticExceptions)
                    .concat(coralOperation.modelledExceptions)
                    .find(errorConstructor => errorConstructor.fullyQualifiedTypeName === body.__type);
                if (exception) {
                    // tslint:disable-next-line:no-non-null-assertion
                    throw new CoralResponse(Object.assign(Object.assign({}, response), { body: exception.fromJson(body) }));
                }
                // Unmodelled Exception
                throw new CoralResponse(Object.assign(Object.assign({}, response), { body: new UnknownCoralError(body, response.status) }));
            }
        }));
    }
    withSerializedBody(request) {
        const coralOperation = this.operations[request.operation];
        if (!coralOperation)
            return request;
        const serializationFn = coralOperation.serializationFn;
        if (serializationFn) {
            return request.clone({ body: serializationFn(request.body) });
        }
        else {
            if (!request.body || !(request.body instanceof CoralModel))
                return request;
            const body = request.body.constructor.toJson(request.body);
            return request.clone({ body });
        }
    }
}
